import { Icon, Icons } from "@phoenix/components/icon";

export const SearchIcon = () => {
  return <Icon className="ac-search-icon" svg={<Icons.Search />} />;
};
